/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PulseIndexRouteImport } from './routes/pulse/index'
import { Route as DashboardThoughtspotRouteImport } from './routes/dashboard/_thoughtspot'
import { Route as DashboardPrimaryRoutesRouteImport } from './routes/dashboard/_primary-routes'
import { Route as DashboardDeepLinksRouteImport } from './routes/dashboard/_deep-links'
import { Route as DashboardThoughtspotSchedulesRouteImport } from './routes/dashboard/_thoughtspot/schedules'
import { Route as DashboardThoughtspotPageRouteImport } from './routes/dashboard/_thoughtspot/$page'
import { Route as DashboardPrimaryRoutesSupportAccessRouteImport } from './routes/dashboard/_primary-routes/support-access'
import { Route as DashboardPrimaryRoutesSparkRouteImport } from './routes/dashboard/_primary-routes/spark'
import { Route as DashboardPrimaryRoutesSourceRouteImport } from './routes/dashboard/_primary-routes/source'
import { Route as DashboardPrimaryRoutesSearchRouteImport } from './routes/dashboard/_primary-routes/search'
import { Route as DashboardPrimaryRoutesQuestionLabelsRouteImport } from './routes/dashboard/_primary-routes/question-labels'
import { Route as DashboardPrimaryRoutesDatasetsRouteImport } from './routes/dashboard/_primary-routes/datasets'
import { Route as DashboardDeepLinksUserPreferenceRouteImport } from './routes/dashboard/_deep-links/user-preference'
import { Route as DashboardDeepLinksUnsubscribeRouteImport } from './routes/dashboard/_deep-links/unsubscribe'
import { Route as DashboardPrimaryRoutesDatasetEditorGuidRouteImport } from './routes/dashboard/_primary-routes/dataset-editor.$guid'
import { Route as DashboardPrimaryRoutesDataSourceTabRouteImport } from './routes/dashboard/_primary-routes/data-source.$tab'
import { Route as DashboardDeepLinksSearchGuidRouteImport } from './routes/dashboard/_deep-links/search.$guid'
import { Route as DashboardDeepLinksPinboardIdRouteImport } from './routes/dashboard/_deep-links/pinboard.$id'
import { Route as DashboardDeepLinksInsightObject_idRouteImport } from './routes/dashboard/_deep-links/insight.$object_id'
import { Route as DashboardDeepLinksDataGuidRouteImport } from './routes/dashboard/_deep-links/data.$guid'
import { Route as DashboardDeepLinksChartsObject_idRouteImport } from './routes/dashboard/_deep-links/charts.$object_id'
import { Route as DashboardDeepLinksAiHighlightObject_idRouteImport } from './routes/dashboard/_deep-links/ai-highlight.$object_id'
import { Route as DashboardDeepLinksPinboardObject_idSub_object_idRouteImport } from './routes/dashboard/_deep-links/pinboard.$object_id.$sub_object_id'

const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PulseIndexRoute = PulseIndexRouteImport.update({
  id: '/pulse/',
  path: '/pulse/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardThoughtspotRoute = DashboardThoughtspotRouteImport.update({
  id: '/_thoughtspot',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPrimaryRoutesRoute = DashboardPrimaryRoutesRouteImport.update({
  id: '/_primary-routes',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDeepLinksRoute = DashboardDeepLinksRouteImport.update({
  id: '/_deep-links',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardThoughtspotSchedulesRoute =
  DashboardThoughtspotSchedulesRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => DashboardThoughtspotRoute,
  } as any)
const DashboardThoughtspotPageRoute =
  DashboardThoughtspotPageRouteImport.update({
    id: '/$page',
    path: '/$page',
    getParentRoute: () => DashboardThoughtspotRoute,
  } as any)
const DashboardPrimaryRoutesSupportAccessRoute =
  DashboardPrimaryRoutesSupportAccessRouteImport.update({
    id: '/support-access',
    path: '/support-access',
    getParentRoute: () => DashboardPrimaryRoutesRoute,
  } as any)
const DashboardPrimaryRoutesSparkRoute =
  DashboardPrimaryRoutesSparkRouteImport.update({
    id: '/spark',
    path: '/spark',
    getParentRoute: () => DashboardPrimaryRoutesRoute,
  } as any)
const DashboardPrimaryRoutesSourceRoute =
  DashboardPrimaryRoutesSourceRouteImport.update({
    id: '/source',
    path: '/source',
    getParentRoute: () => DashboardPrimaryRoutesRoute,
  } as any)
const DashboardPrimaryRoutesSearchRoute =
  DashboardPrimaryRoutesSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => DashboardPrimaryRoutesRoute,
  } as any)
const DashboardPrimaryRoutesQuestionLabelsRoute =
  DashboardPrimaryRoutesQuestionLabelsRouteImport.update({
    id: '/question-labels',
    path: '/question-labels',
    getParentRoute: () => DashboardPrimaryRoutesRoute,
  } as any)
const DashboardPrimaryRoutesDatasetsRoute =
  DashboardPrimaryRoutesDatasetsRouteImport.update({
    id: '/datasets',
    path: '/datasets',
    getParentRoute: () => DashboardPrimaryRoutesRoute,
  } as any)
const DashboardDeepLinksUserPreferenceRoute =
  DashboardDeepLinksUserPreferenceRouteImport.update({
    id: '/user-preference',
    path: '/user-preference',
    getParentRoute: () => DashboardDeepLinksRoute,
  } as any)
const DashboardDeepLinksUnsubscribeRoute =
  DashboardDeepLinksUnsubscribeRouteImport.update({
    id: '/unsubscribe',
    path: '/unsubscribe',
    getParentRoute: () => DashboardDeepLinksRoute,
  } as any)
const DashboardPrimaryRoutesDatasetEditorGuidRoute =
  DashboardPrimaryRoutesDatasetEditorGuidRouteImport.update({
    id: '/dataset-editor/$guid',
    path: '/dataset-editor/$guid',
    getParentRoute: () => DashboardPrimaryRoutesRoute,
  } as any)
const DashboardPrimaryRoutesDataSourceTabRoute =
  DashboardPrimaryRoutesDataSourceTabRouteImport.update({
    id: '/data-source/$tab',
    path: '/data-source/$tab',
    getParentRoute: () => DashboardPrimaryRoutesRoute,
  } as any)
const DashboardDeepLinksSearchGuidRoute =
  DashboardDeepLinksSearchGuidRouteImport.update({
    id: '/search/$guid',
    path: '/search/$guid',
    getParentRoute: () => DashboardDeepLinksRoute,
  } as any)
const DashboardDeepLinksPinboardIdRoute =
  DashboardDeepLinksPinboardIdRouteImport.update({
    id: '/pinboard/$id',
    path: '/pinboard/$id',
    getParentRoute: () => DashboardDeepLinksRoute,
  } as any)
const DashboardDeepLinksInsightObject_idRoute =
  DashboardDeepLinksInsightObject_idRouteImport.update({
    id: '/insight/$object_id',
    path: '/insight/$object_id',
    getParentRoute: () => DashboardDeepLinksRoute,
  } as any)
const DashboardDeepLinksDataGuidRoute =
  DashboardDeepLinksDataGuidRouteImport.update({
    id: '/data/$guid',
    path: '/data/$guid',
    getParentRoute: () => DashboardDeepLinksRoute,
  } as any)
const DashboardDeepLinksChartsObject_idRoute =
  DashboardDeepLinksChartsObject_idRouteImport.update({
    id: '/charts/$object_id',
    path: '/charts/$object_id',
    getParentRoute: () => DashboardDeepLinksRoute,
  } as any)
const DashboardDeepLinksAiHighlightObject_idRoute =
  DashboardDeepLinksAiHighlightObject_idRouteImport.update({
    id: '/ai-highlight/$object_id',
    path: '/ai-highlight/$object_id',
    getParentRoute: () => DashboardDeepLinksRoute,
  } as any)
const DashboardDeepLinksPinboardObject_idSub_object_idRoute =
  DashboardDeepLinksPinboardObject_idSub_object_idRouteImport.update({
    id: '/pinboard/$object_id/$sub_object_id',
    path: '/pinboard/$object_id/$sub_object_id',
    getParentRoute: () => DashboardDeepLinksRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardThoughtspotRouteWithChildren
  '/pulse/': typeof PulseIndexRoute
  '/dashboard/unsubscribe': typeof DashboardDeepLinksUnsubscribeRoute
  '/dashboard/user-preference': typeof DashboardDeepLinksUserPreferenceRoute
  '/dashboard/datasets': typeof DashboardPrimaryRoutesDatasetsRoute
  '/dashboard/question-labels': typeof DashboardPrimaryRoutesQuestionLabelsRoute
  '/dashboard/search': typeof DashboardPrimaryRoutesSearchRoute
  '/dashboard/source': typeof DashboardPrimaryRoutesSourceRoute
  '/dashboard/spark': typeof DashboardPrimaryRoutesSparkRoute
  '/dashboard/support-access': typeof DashboardPrimaryRoutesSupportAccessRoute
  '/dashboard/$page': typeof DashboardThoughtspotPageRoute
  '/dashboard/schedules': typeof DashboardThoughtspotSchedulesRoute
  '/dashboard/ai-highlight/$object_id': typeof DashboardDeepLinksAiHighlightObject_idRoute
  '/dashboard/charts/$object_id': typeof DashboardDeepLinksChartsObject_idRoute
  '/dashboard/data/$guid': typeof DashboardDeepLinksDataGuidRoute
  '/dashboard/insight/$object_id': typeof DashboardDeepLinksInsightObject_idRoute
  '/dashboard/pinboard/$id': typeof DashboardDeepLinksPinboardIdRoute
  '/dashboard/search/$guid': typeof DashboardDeepLinksSearchGuidRoute
  '/dashboard/data-source/$tab': typeof DashboardPrimaryRoutesDataSourceTabRoute
  '/dashboard/dataset-editor/$guid': typeof DashboardPrimaryRoutesDatasetEditorGuidRoute
  '/dashboard/pinboard/$object_id/$sub_object_id': typeof DashboardDeepLinksPinboardObject_idSub_object_idRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardThoughtspotRouteWithChildren
  '/pulse': typeof PulseIndexRoute
  '/dashboard/unsubscribe': typeof DashboardDeepLinksUnsubscribeRoute
  '/dashboard/user-preference': typeof DashboardDeepLinksUserPreferenceRoute
  '/dashboard/datasets': typeof DashboardPrimaryRoutesDatasetsRoute
  '/dashboard/question-labels': typeof DashboardPrimaryRoutesQuestionLabelsRoute
  '/dashboard/search': typeof DashboardPrimaryRoutesSearchRoute
  '/dashboard/source': typeof DashboardPrimaryRoutesSourceRoute
  '/dashboard/spark': typeof DashboardPrimaryRoutesSparkRoute
  '/dashboard/support-access': typeof DashboardPrimaryRoutesSupportAccessRoute
  '/dashboard/$page': typeof DashboardThoughtspotPageRoute
  '/dashboard/schedules': typeof DashboardThoughtspotSchedulesRoute
  '/dashboard/ai-highlight/$object_id': typeof DashboardDeepLinksAiHighlightObject_idRoute
  '/dashboard/charts/$object_id': typeof DashboardDeepLinksChartsObject_idRoute
  '/dashboard/data/$guid': typeof DashboardDeepLinksDataGuidRoute
  '/dashboard/insight/$object_id': typeof DashboardDeepLinksInsightObject_idRoute
  '/dashboard/pinboard/$id': typeof DashboardDeepLinksPinboardIdRoute
  '/dashboard/search/$guid': typeof DashboardDeepLinksSearchGuidRoute
  '/dashboard/data-source/$tab': typeof DashboardPrimaryRoutesDataSourceTabRoute
  '/dashboard/dataset-editor/$guid': typeof DashboardPrimaryRoutesDatasetEditorGuidRoute
  '/dashboard/pinboard/$object_id/$sub_object_id': typeof DashboardDeepLinksPinboardObject_idSub_object_idRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/dashboard/_deep-links': typeof DashboardDeepLinksRouteWithChildren
  '/dashboard/_primary-routes': typeof DashboardPrimaryRoutesRouteWithChildren
  '/dashboard/_thoughtspot': typeof DashboardThoughtspotRouteWithChildren
  '/pulse/': typeof PulseIndexRoute
  '/dashboard/_deep-links/unsubscribe': typeof DashboardDeepLinksUnsubscribeRoute
  '/dashboard/_deep-links/user-preference': typeof DashboardDeepLinksUserPreferenceRoute
  '/dashboard/_primary-routes/datasets': typeof DashboardPrimaryRoutesDatasetsRoute
  '/dashboard/_primary-routes/question-labels': typeof DashboardPrimaryRoutesQuestionLabelsRoute
  '/dashboard/_primary-routes/search': typeof DashboardPrimaryRoutesSearchRoute
  '/dashboard/_primary-routes/source': typeof DashboardPrimaryRoutesSourceRoute
  '/dashboard/_primary-routes/spark': typeof DashboardPrimaryRoutesSparkRoute
  '/dashboard/_primary-routes/support-access': typeof DashboardPrimaryRoutesSupportAccessRoute
  '/dashboard/_thoughtspot/$page': typeof DashboardThoughtspotPageRoute
  '/dashboard/_thoughtspot/schedules': typeof DashboardThoughtspotSchedulesRoute
  '/dashboard/_deep-links/ai-highlight/$object_id': typeof DashboardDeepLinksAiHighlightObject_idRoute
  '/dashboard/_deep-links/charts/$object_id': typeof DashboardDeepLinksChartsObject_idRoute
  '/dashboard/_deep-links/data/$guid': typeof DashboardDeepLinksDataGuidRoute
  '/dashboard/_deep-links/insight/$object_id': typeof DashboardDeepLinksInsightObject_idRoute
  '/dashboard/_deep-links/pinboard/$id': typeof DashboardDeepLinksPinboardIdRoute
  '/dashboard/_deep-links/search/$guid': typeof DashboardDeepLinksSearchGuidRoute
  '/dashboard/_primary-routes/data-source/$tab': typeof DashboardPrimaryRoutesDataSourceTabRoute
  '/dashboard/_primary-routes/dataset-editor/$guid': typeof DashboardPrimaryRoutesDatasetEditorGuidRoute
  '/dashboard/_deep-links/pinboard/$object_id/$sub_object_id': typeof DashboardDeepLinksPinboardObject_idSub_object_idRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/pulse/'
    | '/dashboard/unsubscribe'
    | '/dashboard/user-preference'
    | '/dashboard/datasets'
    | '/dashboard/question-labels'
    | '/dashboard/search'
    | '/dashboard/source'
    | '/dashboard/spark'
    | '/dashboard/support-access'
    | '/dashboard/$page'
    | '/dashboard/schedules'
    | '/dashboard/ai-highlight/$object_id'
    | '/dashboard/charts/$object_id'
    | '/dashboard/data/$guid'
    | '/dashboard/insight/$object_id'
    | '/dashboard/pinboard/$id'
    | '/dashboard/search/$guid'
    | '/dashboard/data-source/$tab'
    | '/dashboard/dataset-editor/$guid'
    | '/dashboard/pinboard/$object_id/$sub_object_id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/pulse'
    | '/dashboard/unsubscribe'
    | '/dashboard/user-preference'
    | '/dashboard/datasets'
    | '/dashboard/question-labels'
    | '/dashboard/search'
    | '/dashboard/source'
    | '/dashboard/spark'
    | '/dashboard/support-access'
    | '/dashboard/$page'
    | '/dashboard/schedules'
    | '/dashboard/ai-highlight/$object_id'
    | '/dashboard/charts/$object_id'
    | '/dashboard/data/$guid'
    | '/dashboard/insight/$object_id'
    | '/dashboard/pinboard/$id'
    | '/dashboard/search/$guid'
    | '/dashboard/data-source/$tab'
    | '/dashboard/dataset-editor/$guid'
    | '/dashboard/pinboard/$object_id/$sub_object_id'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/dashboard/_deep-links'
    | '/dashboard/_primary-routes'
    | '/dashboard/_thoughtspot'
    | '/pulse/'
    | '/dashboard/_deep-links/unsubscribe'
    | '/dashboard/_deep-links/user-preference'
    | '/dashboard/_primary-routes/datasets'
    | '/dashboard/_primary-routes/question-labels'
    | '/dashboard/_primary-routes/search'
    | '/dashboard/_primary-routes/source'
    | '/dashboard/_primary-routes/spark'
    | '/dashboard/_primary-routes/support-access'
    | '/dashboard/_thoughtspot/$page'
    | '/dashboard/_thoughtspot/schedules'
    | '/dashboard/_deep-links/ai-highlight/$object_id'
    | '/dashboard/_deep-links/charts/$object_id'
    | '/dashboard/_deep-links/data/$guid'
    | '/dashboard/_deep-links/insight/$object_id'
    | '/dashboard/_deep-links/pinboard/$id'
    | '/dashboard/_deep-links/search/$guid'
    | '/dashboard/_primary-routes/data-source/$tab'
    | '/dashboard/_primary-routes/dataset-editor/$guid'
    | '/dashboard/_deep-links/pinboard/$object_id/$sub_object_id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  PulseIndexRoute: typeof PulseIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pulse/': {
      id: '/pulse/'
      path: '/pulse'
      fullPath: '/pulse/'
      preLoaderRoute: typeof PulseIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/_thoughtspot': {
      id: '/dashboard/_thoughtspot'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardThoughtspotRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/_primary-routes': {
      id: '/dashboard/_primary-routes'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardPrimaryRoutesRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/_deep-links': {
      id: '/dashboard/_deep-links'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardDeepLinksRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/_thoughtspot/schedules': {
      id: '/dashboard/_thoughtspot/schedules'
      path: '/schedules'
      fullPath: '/dashboard/schedules'
      preLoaderRoute: typeof DashboardThoughtspotSchedulesRouteImport
      parentRoute: typeof DashboardThoughtspotRoute
    }
    '/dashboard/_thoughtspot/$page': {
      id: '/dashboard/_thoughtspot/$page'
      path: '/$page'
      fullPath: '/dashboard/$page'
      preLoaderRoute: typeof DashboardThoughtspotPageRouteImport
      parentRoute: typeof DashboardThoughtspotRoute
    }
    '/dashboard/_primary-routes/support-access': {
      id: '/dashboard/_primary-routes/support-access'
      path: '/support-access'
      fullPath: '/dashboard/support-access'
      preLoaderRoute: typeof DashboardPrimaryRoutesSupportAccessRouteImport
      parentRoute: typeof DashboardPrimaryRoutesRoute
    }
    '/dashboard/_primary-routes/spark': {
      id: '/dashboard/_primary-routes/spark'
      path: '/spark'
      fullPath: '/dashboard/spark'
      preLoaderRoute: typeof DashboardPrimaryRoutesSparkRouteImport
      parentRoute: typeof DashboardPrimaryRoutesRoute
    }
    '/dashboard/_primary-routes/source': {
      id: '/dashboard/_primary-routes/source'
      path: '/source'
      fullPath: '/dashboard/source'
      preLoaderRoute: typeof DashboardPrimaryRoutesSourceRouteImport
      parentRoute: typeof DashboardPrimaryRoutesRoute
    }
    '/dashboard/_primary-routes/search': {
      id: '/dashboard/_primary-routes/search'
      path: '/search'
      fullPath: '/dashboard/search'
      preLoaderRoute: typeof DashboardPrimaryRoutesSearchRouteImport
      parentRoute: typeof DashboardPrimaryRoutesRoute
    }
    '/dashboard/_primary-routes/question-labels': {
      id: '/dashboard/_primary-routes/question-labels'
      path: '/question-labels'
      fullPath: '/dashboard/question-labels'
      preLoaderRoute: typeof DashboardPrimaryRoutesQuestionLabelsRouteImport
      parentRoute: typeof DashboardPrimaryRoutesRoute
    }
    '/dashboard/_primary-routes/datasets': {
      id: '/dashboard/_primary-routes/datasets'
      path: '/datasets'
      fullPath: '/dashboard/datasets'
      preLoaderRoute: typeof DashboardPrimaryRoutesDatasetsRouteImport
      parentRoute: typeof DashboardPrimaryRoutesRoute
    }
    '/dashboard/_deep-links/user-preference': {
      id: '/dashboard/_deep-links/user-preference'
      path: '/user-preference'
      fullPath: '/dashboard/user-preference'
      preLoaderRoute: typeof DashboardDeepLinksUserPreferenceRouteImport
      parentRoute: typeof DashboardDeepLinksRoute
    }
    '/dashboard/_deep-links/unsubscribe': {
      id: '/dashboard/_deep-links/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/dashboard/unsubscribe'
      preLoaderRoute: typeof DashboardDeepLinksUnsubscribeRouteImport
      parentRoute: typeof DashboardDeepLinksRoute
    }
    '/dashboard/_primary-routes/dataset-editor/$guid': {
      id: '/dashboard/_primary-routes/dataset-editor/$guid'
      path: '/dataset-editor/$guid'
      fullPath: '/dashboard/dataset-editor/$guid'
      preLoaderRoute: typeof DashboardPrimaryRoutesDatasetEditorGuidRouteImport
      parentRoute: typeof DashboardPrimaryRoutesRoute
    }
    '/dashboard/_primary-routes/data-source/$tab': {
      id: '/dashboard/_primary-routes/data-source/$tab'
      path: '/data-source/$tab'
      fullPath: '/dashboard/data-source/$tab'
      preLoaderRoute: typeof DashboardPrimaryRoutesDataSourceTabRouteImport
      parentRoute: typeof DashboardPrimaryRoutesRoute
    }
    '/dashboard/_deep-links/search/$guid': {
      id: '/dashboard/_deep-links/search/$guid'
      path: '/search/$guid'
      fullPath: '/dashboard/search/$guid'
      preLoaderRoute: typeof DashboardDeepLinksSearchGuidRouteImport
      parentRoute: typeof DashboardDeepLinksRoute
    }
    '/dashboard/_deep-links/pinboard/$id': {
      id: '/dashboard/_deep-links/pinboard/$id'
      path: '/pinboard/$id'
      fullPath: '/dashboard/pinboard/$id'
      preLoaderRoute: typeof DashboardDeepLinksPinboardIdRouteImport
      parentRoute: typeof DashboardDeepLinksRoute
    }
    '/dashboard/_deep-links/insight/$object_id': {
      id: '/dashboard/_deep-links/insight/$object_id'
      path: '/insight/$object_id'
      fullPath: '/dashboard/insight/$object_id'
      preLoaderRoute: typeof DashboardDeepLinksInsightObject_idRouteImport
      parentRoute: typeof DashboardDeepLinksRoute
    }
    '/dashboard/_deep-links/data/$guid': {
      id: '/dashboard/_deep-links/data/$guid'
      path: '/data/$guid'
      fullPath: '/dashboard/data/$guid'
      preLoaderRoute: typeof DashboardDeepLinksDataGuidRouteImport
      parentRoute: typeof DashboardDeepLinksRoute
    }
    '/dashboard/_deep-links/charts/$object_id': {
      id: '/dashboard/_deep-links/charts/$object_id'
      path: '/charts/$object_id'
      fullPath: '/dashboard/charts/$object_id'
      preLoaderRoute: typeof DashboardDeepLinksChartsObject_idRouteImport
      parentRoute: typeof DashboardDeepLinksRoute
    }
    '/dashboard/_deep-links/ai-highlight/$object_id': {
      id: '/dashboard/_deep-links/ai-highlight/$object_id'
      path: '/ai-highlight/$object_id'
      fullPath: '/dashboard/ai-highlight/$object_id'
      preLoaderRoute: typeof DashboardDeepLinksAiHighlightObject_idRouteImport
      parentRoute: typeof DashboardDeepLinksRoute
    }
    '/dashboard/_deep-links/pinboard/$object_id/$sub_object_id': {
      id: '/dashboard/_deep-links/pinboard/$object_id/$sub_object_id'
      path: '/pinboard/$object_id/$sub_object_id'
      fullPath: '/dashboard/pinboard/$object_id/$sub_object_id'
      preLoaderRoute: typeof DashboardDeepLinksPinboardObject_idSub_object_idRouteImport
      parentRoute: typeof DashboardDeepLinksRoute
    }
  }
}

interface DashboardDeepLinksRouteChildren {
  DashboardDeepLinksUnsubscribeRoute: typeof DashboardDeepLinksUnsubscribeRoute
  DashboardDeepLinksUserPreferenceRoute: typeof DashboardDeepLinksUserPreferenceRoute
  DashboardDeepLinksAiHighlightObject_idRoute: typeof DashboardDeepLinksAiHighlightObject_idRoute
  DashboardDeepLinksChartsObject_idRoute: typeof DashboardDeepLinksChartsObject_idRoute
  DashboardDeepLinksDataGuidRoute: typeof DashboardDeepLinksDataGuidRoute
  DashboardDeepLinksInsightObject_idRoute: typeof DashboardDeepLinksInsightObject_idRoute
  DashboardDeepLinksPinboardIdRoute: typeof DashboardDeepLinksPinboardIdRoute
  DashboardDeepLinksSearchGuidRoute: typeof DashboardDeepLinksSearchGuidRoute
  DashboardDeepLinksPinboardObject_idSub_object_idRoute: typeof DashboardDeepLinksPinboardObject_idSub_object_idRoute
}

const DashboardDeepLinksRouteChildren: DashboardDeepLinksRouteChildren = {
  DashboardDeepLinksUnsubscribeRoute: DashboardDeepLinksUnsubscribeRoute,
  DashboardDeepLinksUserPreferenceRoute: DashboardDeepLinksUserPreferenceRoute,
  DashboardDeepLinksAiHighlightObject_idRoute:
    DashboardDeepLinksAiHighlightObject_idRoute,
  DashboardDeepLinksChartsObject_idRoute:
    DashboardDeepLinksChartsObject_idRoute,
  DashboardDeepLinksDataGuidRoute: DashboardDeepLinksDataGuidRoute,
  DashboardDeepLinksInsightObject_idRoute:
    DashboardDeepLinksInsightObject_idRoute,
  DashboardDeepLinksPinboardIdRoute: DashboardDeepLinksPinboardIdRoute,
  DashboardDeepLinksSearchGuidRoute: DashboardDeepLinksSearchGuidRoute,
  DashboardDeepLinksPinboardObject_idSub_object_idRoute:
    DashboardDeepLinksPinboardObject_idSub_object_idRoute,
}

const DashboardDeepLinksRouteWithChildren =
  DashboardDeepLinksRoute._addFileChildren(DashboardDeepLinksRouteChildren)

interface DashboardPrimaryRoutesRouteChildren {
  DashboardPrimaryRoutesDatasetsRoute: typeof DashboardPrimaryRoutesDatasetsRoute
  DashboardPrimaryRoutesQuestionLabelsRoute: typeof DashboardPrimaryRoutesQuestionLabelsRoute
  DashboardPrimaryRoutesSearchRoute: typeof DashboardPrimaryRoutesSearchRoute
  DashboardPrimaryRoutesSourceRoute: typeof DashboardPrimaryRoutesSourceRoute
  DashboardPrimaryRoutesSparkRoute: typeof DashboardPrimaryRoutesSparkRoute
  DashboardPrimaryRoutesSupportAccessRoute: typeof DashboardPrimaryRoutesSupportAccessRoute
  DashboardPrimaryRoutesDataSourceTabRoute: typeof DashboardPrimaryRoutesDataSourceTabRoute
  DashboardPrimaryRoutesDatasetEditorGuidRoute: typeof DashboardPrimaryRoutesDatasetEditorGuidRoute
}

const DashboardPrimaryRoutesRouteChildren: DashboardPrimaryRoutesRouteChildren =
  {
    DashboardPrimaryRoutesDatasetsRoute: DashboardPrimaryRoutesDatasetsRoute,
    DashboardPrimaryRoutesQuestionLabelsRoute:
      DashboardPrimaryRoutesQuestionLabelsRoute,
    DashboardPrimaryRoutesSearchRoute: DashboardPrimaryRoutesSearchRoute,
    DashboardPrimaryRoutesSourceRoute: DashboardPrimaryRoutesSourceRoute,
    DashboardPrimaryRoutesSparkRoute: DashboardPrimaryRoutesSparkRoute,
    DashboardPrimaryRoutesSupportAccessRoute:
      DashboardPrimaryRoutesSupportAccessRoute,
    DashboardPrimaryRoutesDataSourceTabRoute:
      DashboardPrimaryRoutesDataSourceTabRoute,
    DashboardPrimaryRoutesDatasetEditorGuidRoute:
      DashboardPrimaryRoutesDatasetEditorGuidRoute,
  }

const DashboardPrimaryRoutesRouteWithChildren =
  DashboardPrimaryRoutesRoute._addFileChildren(
    DashboardPrimaryRoutesRouteChildren,
  )

interface DashboardThoughtspotRouteChildren {
  DashboardThoughtspotPageRoute: typeof DashboardThoughtspotPageRoute
  DashboardThoughtspotSchedulesRoute: typeof DashboardThoughtspotSchedulesRoute
}

const DashboardThoughtspotRouteChildren: DashboardThoughtspotRouteChildren = {
  DashboardThoughtspotPageRoute: DashboardThoughtspotPageRoute,
  DashboardThoughtspotSchedulesRoute: DashboardThoughtspotSchedulesRoute,
}

const DashboardThoughtspotRouteWithChildren =
  DashboardThoughtspotRoute._addFileChildren(DashboardThoughtspotRouteChildren)

interface DashboardRouteRouteChildren {
  DashboardDeepLinksRoute: typeof DashboardDeepLinksRouteWithChildren
  DashboardPrimaryRoutesRoute: typeof DashboardPrimaryRoutesRouteWithChildren
  DashboardThoughtspotRoute: typeof DashboardThoughtspotRouteWithChildren
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardDeepLinksRoute: DashboardDeepLinksRouteWithChildren,
  DashboardPrimaryRoutesRoute: DashboardPrimaryRoutesRouteWithChildren,
  DashboardThoughtspotRoute: DashboardThoughtspotRouteWithChildren,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  PulseIndexRoute: PulseIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
